import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-storage-ionic',
  templateUrl: './storage-ionic.component.html',
  styleUrls: ['./storage-ionic.component.css']
})
export class StorageIonicComponent implements OnInit {
  code:string = "this.datosUser = {nombre: 'Andres', edad: 23, mayorEdad: true} <br> this.storage.set('DatosUser',  {this.datosUser}); "

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/Utilidades/storage-ionic/storage-ionic.component.ts